import React from "react";
import { LoginProvider } from "../provider";
import useLoginWithAzure from "./useLoginWithAzure";
import AzureSso from "./AzureSso";

function Button() {
  const handleAuthenticationMethod = useLoginWithAzure();

  return <AzureSso onAuthenticated={handleAuthenticationMethod} />;
}

/**
 * Button for azure based login flow
 * @returns {JSX.Element}
 * @constructor
 */
function AzureAuthenticationLogin() {
  return (
    <LoginProvider>
      <Button />
    </LoginProvider>
  );
}

export default AzureAuthenticationLogin;
